/* Global Jquery */
import { MapStyle } from './Components/MemberDirectory/Components/Members/Map/MapStyle';

global.jQuery = require('jquery');
window.jQuery = window.$ = jQuery;

// import Vue from "vue";

require('./Components/jquery.range-min.js');
require('./Components/modernizr.custom.js');
require('./Components/jquery.meanmenu.min.js');
require('selectize/dist/js/standalone/selectize.js');

import axios from 'axios';
import slick from 'slick-carousel';
import parsley from 'parsleyjs';
import swal2 from 'sweetalert2';
// import Maplace from 'maplace-js';
// import infiniteScroll from 'infinite-scroll';

let debounce = require('debounce');

// window.Vue = require('vue');

window.isMobile = false;

$('#mapButton').prop('checked', true);

(function () {
  let main = {
    init: function () {
      this.homepageSliders();
      this.menuPosition();
      this.tabs();
      this.fileInput();
      this.signUp();
      this.newsListing();
      this.smoothLinks();
      this.filterTrigger();

      // this.modal();

      this.subNav();

      /* Calculator */
      this.jqueryRange();
      this.updatePrice();
    },

    detectDevice: function () {
      window.mobileCheck = function () {
        let check = false;
        (function (a) {
          if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
              a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              a.substr(0, 4)
            )
          )
            check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        window.isMobile = check;
      };
    },

    bindEvents: function () {
      /* Checked Toggles */
      $('.selection-wrap input:radio').change(function () {
        if ($(this).is(':checked')) {
          $(this).closest('.select-wrap').find('.active').removeClass('active');
          $(this).parent().addClass('active');
        }
      });

      $('.tick input:checkbox').change(function () {
        $(this).parent().toggleClass('checked');
        $(this).closest('.question-wrap').toggleClass('gold');
      });
    },

    smoothLinks: function () {
      //SCROLLING LINKS
      $('.meet .subnav a').click(function () {
        $('html, body').animate(
          {
            scrollTop: $($.attr(this, 'href')).offset().top - 100,
          },
          200
        );
      });
    },

    filterTrigger: function () {
      $('.filter_filter button').click(function () {
        $('.filter-modal').toggleClass('active');
      });
      $('.filter-modal .close').click(function () {
        $('.filter-modal').removeClass('active');
      });
    },

    modal: function () {
      $('.start__trial--btn').click(function (e) {
        event.preventDefault();
        let target = $(this).data('target');
        $('#' + target).fadeIn();
        $('#' + target).addClass('active');
      });

      $('.made-navigator-close').click(function (event) {
        event.preventDefault();
        $('.modal').removeClass('active');
        $('#made-navigator-modal').fadeOut();
        $('#made-navigator-modal').removeClass('active');
        $('#membership-type').removeClass('done');
        $('#membership-type').removeClass('active');
        $('input.radio-membership-type').each(function (index, element) {
          if (!$(element).is(':checked')) {
            $(element).parent().slideDown();
          }
        });
      });

      $('#made-navigator-modal').click(function (event) {
        event.preventDefault();
        $('.modal').removeClass('active');
        $('#made-navigator-modal').removeClass('active');
        $('#made-navigator-modal').fadeOut();
        $('#membership-type').removeClass('done');
        $('#membership-type').removeClass('active');
        $('input.radio-membership-type').each(function (index, element) {
          if (!$(element).is(':checked')) {
            $(element).parent().slideDown();
          }
        });
      });
    },

    subNav: function () {
      var timeout;

      $('nav a.has-dropdown').on('click', function (event) {
        event.preventDefault();
      });

      $('nav a.has-dropdown').on('mouseenter focus', function (event) {
        var target = $(this).attr('href');
        $(target).css(
          'top',
          $(this).offset().top + $(this)[0].offsetHeight + 'px'
        );
        $(target).css('left', $(this).offset().left + 'px');
        $(target).addClass('active');
      });

      $('nav a.has-dropdown').on('mouseleave blur', function (event) {
        var target = $(this).attr('href');
        timeout = setTimeout(function () {
          $(target).removeClass('active');
        }, 200);
      });

      $('ul.sub--nav__dropdown').mouseenter(function (event) {
        var _dropdown = this;
        clearTimeout(timeout);
        $(_dropdown).addClass('active');
      });

      $('ul.sub--nav__dropdown').mouseleave(function (event) {
        var _dropdown = this;
        timeout = setTimeout(function () {
          $(_dropdown).removeClass('active');
        }, 500);
      });
    },

    jqueryRange: function () {
      $(window).resize(function () {
        /* Sliders */
        this.bEvents = $('.bEvents');
        this.prOpps = $('.prOpps');

        if ($(window).width() < 600) {
          this.bEvents.jRange({
            from: 0,
            to: 12,
            scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            width: 280,
            snap: true,
          });

          this.prOpps.jRange({
            from: 0,
            to: 12,
            scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            width: 280,
            snap: true,
          });
        } else {
          this.bEvents.jRange({
            from: 0,
            to: 12,
            scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            width: 400,
            snap: true,
          });

          this.prOpps.jRange({
            from: 0,
            to: 12,
            scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            width: 400,
            snap: true,
          });
        }
      });

      $(window).trigger('resize');
    },

    updatePrice: function () {
      /* Calculate Sidebar Prices */
      function sidebarUpdate() {
        $('.question-wrap').each(function (index) {
          let calcIndex = index + 1,
            getInput = $(this).find('input'),
            liList = $('.calculations ol');

          if (getInput.is(':radio')) {
            let radioValue = $(this).find('input:checked').attr('data-price');
            liList
              .find('li:nth-child(' + calcIndex + ') .price-calc')
              .text(radioValue);
          } else if (getInput.is(':checkbox')) {
            let price = getInput.data('price');
            if (getInput.is(':checked')) {
              liList
                .find('li:nth-child(' + calcIndex + ') .price-calc')
                .text(price);
            } else {
              liList
                .find('li:nth-child(' + calcIndex + ') .price-calc')
                .text(0);
            }
          } else if (getInput.is(':hidden')) {
            let hiddenValue = getInput.val();

            if (index == 1) {
              let eventsPrice = hiddenValue * 300;
              liList
                .find('li:nth-child(' + calcIndex + ') .price-calc')
                .text(eventsPrice);
            } else if (index == 2) {
              let articlesPrice = hiddenValue * 350;
              liList
                .find('li:nth-child(' + calcIndex + ') .price-calc')
                .text(articlesPrice);
            }
          }
        });
      }

      /* Calculate Real World Total */
      function calculateTotal() {
        let sum = 0;

        /* Calculate Total */
        $('.price-calc').each(function () {
          sum += parseFloat($(this).text().substr());
        });

        /* Parse Total */
        $('.price-total').text('£' + Math.round(sum * 100) / 100);
      }

      /* Update Membership Recommendation */
      function updateRecommended() {
        let membership = [],
          url =
            location.protocol + '//' + location.host + '/members?membership=';

        $('input:checked').each(function (i, e) {
          membership.push($(e).val());
        });

        if ($.inArray('bronze', membership) != -1) {
          $('h3.recom')
            .removeClass()
            .addClass('recom bronze')
            .find('span')
            .text('Bronze');
          $('.mim-price').html(app.bronzePrice + ' <strong>Per Month</strong>');
          $('.signup').prop('href', url + 'bronze');
        }
        if ($.inArray('silver', membership) != -1) {
          $('h3.recom')
            .removeClass()
            .addClass('recom silver')
            .find('span')
            .text('Silver');
          $('.mim-price').html(app.silverPrice + ' <strong>Per Month</strong>');
          $('.signup').prop('href', url + 'silver');
        }
        if ($.inArray('gold', membership) != -1) {
          $('h3.recom')
            .removeClass()
            .addClass('recom gold')
            .find('span')
            .text('Gold');
          $('.mim-price').html(app.goldPrice + ' <strong>Per Month</strong>');
          $('.signup').prop('href', url + 'gold');
        }
      }

      /* On Form Change Update All */
      $('input, select').change(function () {
        sidebarUpdate();
        calculateTotal();
        updateRecommended();
      });

      /* On Load Update All */
      sidebarUpdate();
      calculateTotal();
      updateRecommended();
    },

    signUp: function () {
      // Update Membership Type
      $('.select-group').on('click', 'label', function () {
        $('.select-group label').each(function () {
          $(this).removeClass('active');
        });

        $(this).addClass('active');

        let bronzeInitial = window.price.bronzeInitial,
          bronzeMonthly = window.price.bronzeMonthly,
          digitalInitial = window.price.digitalInitial,
          digitalMonthly = window.price.digitalMonthly;

        if ($(this).text() === 'Freemium') {
          $('.price').text('Free');
          $('.price-subtitle').hide();
          $('.price-monthly').hide();
        }

        if ($(this).text() === 'Bronze') {
          $('.price').text(`Joining Fee: ${bronzeInitial}`);
          $('.price-subtitle').show().text('(only payable upon joining)');
          $('.price-monthly').show().text(`Monthly Price: ${bronzeMonthly}`);
        }

        if ($(this).text() === 'Digital') {
          $('.price').text(`Joining Fee: ${digitalInitial}`);
          $('.price-subtitle').show().text('(only payable upon joining)');
          $('.price-monthly').show().text(`Monthly Price: ${digitalMonthly}`);
        }
      });

      $(document).ready(function () {
        $('.company-information .selectize-input input').attr(
          'data-parsley-errors-container',
          '.cb2'
        );

        var selectedMembershipLabel = $('.select-group label.active');

        if (
          typeof selectedMembershipLabel !== typeof undefined &&
          typeof selectedMembershipLabel !== typeof false
        ) {
          var selectedMembership = selectedMembershipLabel.attr('for');

          if (
            typeof selectedMembership !== typeof undefined &&
            typeof selectedMembership !== typeof false
          ) {
            $('#' + selectedMembership).prop('checked', true);

            let bronzeInitial = window.price.bronzeInitial,
              bronzeMonthly = window.price.bronzeMonthly,
              digitalInitial = window.price.digitalInitial,
              digitalMonthly = window.price.digitalMonthly;

            if (selectedMembershipLabel.text() === 'Freemium') {
              $('.price').text('Free');
              $('.price-subtitle').hide();
              $('.price-monthly').hide();
            }

            if (selectedMembershipLabel.text() === 'Bronze') {
              $('.price').text(`Joining Fee: ${bronzeInitial}`);
              $('.price-subtitle').show().text('(only payable upon joining)');
              $('.price-monthly')
                .show()
                .text(`Monthly Price: ${bronzeMonthly}`);
            }

            if (selectedMembershipLabel.text() === 'Digital') {
              $('.price').text(`Joining Fee: ${digitalInitial}`);
              $('.price-subtitle').show().text('(only payable upon joining)');
              $('.price-monthly')
                .show()
                .text(`Monthly Price: ${digitalMonthly}`);
            }
          }
        }
      });

      $('#signup').parsley({
        excluded:
          'input[type=button], input[type=submit], input[type=reset], input[type=hidden], input:hidden',
        errorsWrapper: '<span class="form-alert"></span>',
        errorTemplate: '<span></span>',
        errorMessage: 'Required',
      });
    },

    fileInput: function () {
      $('.inputfile').each(function () {
        let $input = $(this),
          $label = $input.next('label'),
          labelVal = $label.html();

        $input.on('change', function (e) {
          let fileName = '';

          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute('data-multiple-caption') || ''
            ).replace('{count}', this.files.length);
          else if (e.target.value) fileName = e.target.value.split('\\').pop();

          if (fileName) $label.find('span').html(fileName);
          else $label.html(labelVal);
        });

        // Firefox bug fix
        $input
          .on('focus', function () {
            $input.addClass('has-focus');
          })
          .on('blur', function () {
            $input.removeClass('has-focus');
          });
      });
    },

    tabs: function () {
      $('.tab').on('click', '.tab__nav__item', function () {
        let t = $(this).attr('href');

        $('.tab__nav__item').removeClass('tab__nav__item--active');
        $(this).addClass('tab__nav__item--active');

        $('.tab__content').each(function () {
          $(this).is(t)
            ? $(this).addClass('tab__content--active')
            : $(this).removeClass('tab__content--active');
        });

        return false;
      });
    },

    menuPosition: function () {
      // $(document).ready(function () {
      //     $('.navigation__item').each(function (i) {
      //         let position = (i == 0 ? $(this).position().left : $(this).position().left + 22);
      //         $(this).find('> ul').css('left', position);
      //     });
      // });

      $('.dropdown').hover(
        function () {
          $(this).addClass('dropdown--active');
        },
        function () {
          $(this).removeClass('dropdown--active');
        }
      );
    },

    homepageSliders: function () {
      // Breakpoint Generator Function
      let breakPointGenerator = (breakPointList) => {
        let arr = [];

        breakPointList.forEach((entry) => {
          let breakPoint = {
            breakpoint: entry.breakpoint,
            settings: {
              slidesToShow: entry.slides,
              slidesToScroll: entry.slides,
            },
          };

          arr.push(breakPoint);
        });

        return arr;
      };

      // Global Slider Settings
      let settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
      };

      // Event & News Sliders
      $('.testimonials__wrap__slider').slick({
        ...settings,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      $('.custom-nav-container.testimonial .prev').click(function () {
        $('.testimonials__wrap__slider').slick('slickPrev');
      });
      $('.custom-nav-container.testimonial .next').click(function () {
        $('.testimonials__wrap__slider').slick('slickNext');
      });

      // Members Logos Carousel
      let breakPoints = [
        {
          breakpoint: 1200,
          slides: 4,
        },
        {
          breakpoint: 1024,
          slides: 3,
        },
        {
          breakpoint: 768,
          slides: 2,
        },
        {
          breakpoint: 480,
          slides: 1,
        },
      ];

      $('.members__list').slick({
        ...settings,
        lazyLoad: 'progressive',
        slidesToShow: 5,
        arrows: false,
        autoplay: true,
        swipeToSlide: true,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        responsive: breakPointGenerator(breakPoints),
      });

      $('.custom-nav-container.logo .prev').click(function () {
        $('.members__list').slick('slickPrev');
      });
      $('.custom-nav-container.logo .next').click(function () {
        $('.members__list').slick('slickNext');
      });

      $('.events__slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        lazyLoad: 'progressive',
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        swipeToSlide: true,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slides: 3,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slides: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slides: 1,
            },
          },
        ],
      });

      // $('.co .prev').click(function(){
      //     $('.members__list').slick('slickPrev');
      // });
      // $('.custom-nav-container.logo .next').click(function(){
      //     $('.members__list').slick('slickNext');
      // });
    },

    newsListing: function () {
      $('.news-wrap #news-categories').change(function () {
        window.location.href = '?category_id=' + $(this).val();
      });
    },
  };

  main.init();
})();

// CLASSIE FOR INPUTS
(function () {
  // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
  if (!String.prototype.trim) {
    (function () {
      // Make sure we trim BOM and NBSP
      let rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
      String.prototype.trim = function () {
        return this.replace(rtrim, '');
      };
    })();
  }

  [].slice
    .call(document.querySelectorAll('.input-field'))
    .forEach(function (inputEl) {
      // in case the input is already filled..
      if (inputEl.value.trim() !== '') {
        classie.add(inputEl.parentNode, 'input-filled');
      }

      // events:
      inputEl.addEventListener('focus', onInputFocus);
      inputEl.addEventListener('blur', onInputBlur);
    });

  function onInputFocus(ev) {
    classie.add(ev.target.parentNode, 'input-filled');
  }

  function onInputBlur(ev) {
    if (ev.target.value.trim() === '') {
      classie.remove(ev.target.parentNode, 'input-filled');
    }
  }
})();

// MOBILE MENU
$(document).ready(function () {
  $('header nav').meanmenu({
    meanScreenWidth: '992',
    meanMenuContainer: '.navigation .navigation__content',
  });

  // $('button.option__view-details').click(function(event) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     if ($(this).parent().parent().parent().parent().parent().hasClass('show-details')) {
  //         $(this).parent().parent().parent().parent().find('.membership__option--details').slideUp();
  //         $(this).parent().parent().parent().parent().parent().removeClass('show-details');
  //         $(this).find('span').text('View Details');
  //     } else {
  //         $(this).parent().parent().parent().parent().find('.membership__option--details').slideDown();
  //         $(this).parent().parent().parent().parent().parent().addClass('show-details');
  //         $(this).find('span').text('Hide Details');
  //     }
  // });

  // $('input.radio-membership-type').change(function(event) {
  //     if ($(this).data('name').toLowerCase() === 'freemium' || $(this).data('name').toLowerCase() === 'made navigator' || $(this).data('name').toLowerCase() === 'made navigator online') {
  //         $('#made-navigator-modal').fadeIn();
  //         $('#made-navigator-modal').addClass('active');
  //     } else {
  //         $('#membership-type').removeClass('active');
  //         $('#membership-type').addClass('done');
  //         $('#user-details').addClass('active');

  //         // $('input.radio-membership-type').each(function(index, element) {
  //         //     if (!$(element).is(':checked')) {
  //         //         $(element).parent().slideUp();
  //         //     }
  //         // });
  //     }
  // });

  // $('button.edit__step-btn').click(function(event) {
  //     event.preventDefault();
  //     $('.registration__step--block').removeClass('active');
  //     if ($(this).data('step-id') === 'membership-type') {
  //         $('input.radio-membership-type').each(function(index, element) {
  //             if (!$(element).is(':checked')) {
  //                 $(element).parent().slideDown();
  //             }
  //         });
  //     }
  //     $('#' + $(this).data('step-id')).addClass('active');
  //     if ($(this).data('step-id') === 'user-details' || $(this).data('step-id') === 'company-details') {
  //         $('#' + $(this).data('step-id') + ' .registration__step--inputs').slideDown();
  //     }
  // });

  // $('.registration__step--heading').click(function(event) {
  //     event.preventDefault();
  //     if ($('#' + $(this).data('step-id')).hasClass('done')) {
  //         $('.registration__step--block').removeClass('active');
  //         if ($(this).data('step-id') === 'membership-type') {
  //             $('input.radio-membership-type').each(function(index, element) {
  //                 if (!$(element).is(':checked')) {
  //                     $(element).parent().slideDown();
  //                 }
  //             });
  //         }
  //         $('#' + $(this).data('step-id')).addClass('active');
  //         if ($(this).data('step-id') === 'user-details' || $(this).data('step-id') === 'company-details') {
  //             $('#' + $(this).data('step-id') + ' .registration__step--inputs').slideDown();
  //         }
  //     }
  // });

  // $('button.option__save-continue').click(function(event) {
  //     event.preventDefault();

  //     var isFreemiumMembershipNotSelected = true;
  //     if ($(this).data('step-id') === 'membership-type') {
  //         if ($('input.radio-membership-type:checked').data('name').toLowerCase() === 'freemium' || $('input.radio-membership-type:checked').data('name').toLowerCase() === 'made navigator' || $('input.radio-membership-type:checked').data('name').toLowerCase() === 'made navigator online') {
  //             $('#made-navigator-modal').fadeIn();
  //             $('#made-navigator-modal').addClass('active');
  //             isFreemiumMembershipNotSelected = false;
  //         }
  //         $('input.radio-membership-type').each(function(index, element) {
  //             if (!$(element).is(':checked')) {
  //                 $(element).parent().slideUp();
  //             }
  //         });
  //     }

  //     if ($(this).data('step-id') === 'user-details' || $(this).data('step-id') === 'company-details') {
  //         $('#' + $(this).data('step-id') + ' .registration__step--inputs').slideUp();
  //         $('#' + $(this).data('step-id')).addClass('done');
  //     }

  //     $('#' + $(this).data('step-id')).removeClass('active');
  //     $('#' + $(this).data('step-id')).addClass('done');

  //     if (isFreemiumMembershipNotSelected) {
  //         $('.registration__step--block').removeClass('active');
  //         $('.registration__step--block').not('.done').first().addClass('active');
  //     }
  // });

  // $('input.user-input, input.company-input').each(function(index, input) {
  //     $('#' + $(this).data('id')).text($(input).val());
  //     if ($.trim($(input).val()) !== '') {
  //         $(input).addClass('filled');
  //     }
  // });

  $('#company__location').text($('#contact-details-location').val());

  if ($('#contact-details-location').val() !== '') {
    $('#contact-details-location').addClass('filled');
  } else {
    $('#contact-details-location').removeClass('filled');
  }

  if ($('input.user-input').length === $('input.user-input.filled').length) {
    $('#user-details button.option__save-continue').prop('disabled', false);
  } else {
    $('#user-details button.option__save-continue').prop('disabled', true);
  }

  if (
    $('input.company-input').length === $('input.company-input.filled').length
  ) {
    $('#company-details button.option__save-continue').prop('disabled', false);
  } else {
    $('#company-details button.option__save-continue').prop('disabled', true);
  }

  if (
    $('input#user-password').hasClass('filled') &&
    $('input#user-password-confirmation').hasClass('filled')
  ) {
    $('input#user-password').parent().find('.input--error span').remove();
    $('input#user-password-confirmation')
      .parent()
      .find('.input--error span')
      .remove();
    if (
      $('input#user-password').val() !==
      $('input#user-password-confirmation').val()
    ) {
      var errorText = 'Passwords do not match';
      if (
        $('input#user-password').parent().find('.input--error span').length > 0
      ) {
        $('input#user-password')
          .parent()
          .find('.input--error span')
          .text(errorText);
      } else {
        $('input#user-password')
          .parent()
          .append(
            '<div class="input--error"><span>' + errorText + '</span></div>'
          );
      }

      if (
        $('input#user-password-confirmation')
          .parent()
          .find('.input--error span').length > 0
      ) {
        $('input#user-password-confirmation')
          .parent()
          .find('.input--error span')
          .text(errorText);
      } else {
        $('input#user-password-confirmation')
          .parent()
          .append(
            '<div class="input--error"><span>' + errorText + '</span></div>'
          );
      }

      $('#user-details button.option__save-continue').prop('disabled', true);
    } else {
      $('#user-details button.option__save-continue').prop('disabled', false);
    }
  }

  $('input.user-input, input.company-input').on('input blur', function (event) {
    $('#' + $(this).data('id')).text($(this).val());
    if ($.trim($(this).val()) !== '') {
      $(this).parent().find('.input--error').remove();
      $(this).addClass('filled');
    } else {
      var errorText =
        ($(this).attr('placeholder').toLowerCase().indexOf('password') === -1
          ? 'Please enter your '
          : 'Please enter ') + $(this).attr('placeholder').toLowerCase();
      if ($(this).parent().find('.input--error span').length > 0) {
        $(this).parent().find('.input--error span').text(errorText);
      } else {
        $(this)
          .parent()
          .append(
            '<div class="input--error"><span>' + errorText + '</span></div>'
          );
      }
    }
  });

  $('input.optional-input').each(function (index, input) {
    $('#' + $(input).data('id')).text($(input).val());
  });

  $('input.optional-input').on('input', function (event) {
    $('#' + $(this).data('id')).text($(this).val());
  });

  $('input.user-input').on('input blur', function (event) {
    if ($('input.user-input').length === $('input.user-input.filled').length) {
      $('#user-details button.option__save-continue').prop('disabled', false);
    } else {
      $('#user-details button.option__save-continue').prop('disabled', true);
    }

    if (
      this.id === 'user-password' ||
      this.id === 'user-password-confirmation'
    ) {
      if (
        $('input#user-password').hasClass('filled') &&
        $('input#user-password-confirmation').hasClass('filled')
      ) {
        $('input#user-password').parent().find('.input--error span').remove();
        $('input#user-password-confirmation')
          .parent()
          .find('.input--error span')
          .remove();
        if (
          $('input#user-password').val() !==
          $('input#user-password-confirmation').val()
        ) {
          var errorText = 'Passwords do not match';
          if ($(this).parent().find('.input--error span').length > 0) {
            $(this).parent().find('.input--error span').text(errorText);
          } else {
            $(this)
              .parent()
              .append(
                '<div class="input--error"><span>' + errorText + '</span></div>'
              );
          }
          $('#user-details button.option__save-continue').prop(
            'disabled',
            true
          );
        } else {
          $('#user-details button.option__save-continue').prop(
            'disabled',
            false
          );
        }
      }
    }
  });

  $('input.company-input').on('input blur', function (event) {
    if (
      $('input.company-input').length === $('input.company-input.filled').length
    ) {
      $('#company-details button.option__save-continue').prop(
        'disabled',
        false
      );
    } else {
      $('#company-details button.option__save-continue').prop('disabled', true);
    }
  });

  $('#contact-details-location').change(function (event) {
    $('#company__location').text($(this).val());
    if ($(this).val() !== '') {
      $(this).addClass('filled');
    } else {
      $(this).removeClass('filled');
    }
  });

  // $('button.step__counter').click(function(event) {
  //     event.preventDefault();
  //     // $('.registration__step--block').removeClass('done');
  //     if ($(this).parent().parent().parent().hasClass('done')) {
  //         $('.registration__step--block').removeClass('active');
  //         $('#' + $(this).data('step-id')).addClass('active');
  //     }
  // });

  // var offsetTop = $('.bb-strip').height();

  // $(window).resize(function() {
  //     offsetTop = $('.bb-strip').height();
  //     $('body').css('padding-top', offsetTop + 'px');
  // });

  // if (offsetTop) {
  //     $('.navigation').css('top', offsetTop);
  //     $('body').css('padding-top', offsetTop + 'px');
  // } else {
  //     if ($(window).width() > 700) {
  //         $('.navigation').css('top', offsetTop);
  //         $('body').css('padding-top', offsetTop + 'px');
  //     }
  // }

  // $(document).scroll(function(event) {
  //     var top = offsetTop || 60;

  //     if (window.pageYOffset <= top) {
  //         $('.navigation').css('top', (top - window.pageYOffset) + 'px');
  //     } else {
  //         $('.navigation').css('top', '0px');
  //     }
  // });
});

//MEMBERSHIP BENEFITS TABLE
// $('.flex-row:gt(7)').hide();
// $('.trigger').click(function() {
//     $('.trigger').toggleClass('active');
//     $('.flex-row:gt(7)').toggle();
// });

//STICKY HEADER
$(window).scroll(function () {
  if ($(window).scrollTop() > 1) {
    $('header').addClass('sticky');
  } else {
    $('header').removeClass('sticky');
  }
});
if ($(window).width() < 972) {
  $('header').addClass('sticky');
}

//CALCULATOR SIDEBAR
function sticky_relocate() {
  let window_top = $(window).scrollTop(),
    footer_top = $('.patrons').offset().top,
    div_top = $('#sticky-anchor').offset().top - 115,
    div_height = $('.sidebar-results').height(),
    sidebar_width = $('#sidebar').width(),
    padding = 115; // tweak here or get from margins etc

  if (window_top + div_height > footer_top - padding)
    $('.sidebar-results').css({
      top: (window_top + div_height - footer_top + padding - 115) * -1,
    });
  else if (window_top > div_top) {
    $('.sidebar-results').addClass('stick');
    $('.sidebar-results').css({ top: 115, width: sidebar_width });
  } else {
    $('.sidebar-results').removeClass('stick');
  }
}
if ($('.sidebar-results').length > 0) {
  $(function () {
    $(window).scroll(sticky_relocate);
    sticky_relocate();
  });
}

//CALCULATOR RESULTS FORM
if ($('#email-calculator-results').length > 0) {
  $(function () {
    $('#calculator-results-submit').click(function (event) {
      event.preventDefault();

      let data = $(this).closest('form').serializeArray();
      let results = $('#calculator-form').serializeArray();

      $(results).each(function () {
        data.push(this);
      });

      $.post('', data);
      location.replace('/calculator/thank-you');
    });
  });
}

//SELECTIZE
$('.selectize').selectize();

// GENERIC MODAL
$('.modal .close, .modal').click(function () {
  $('.modal').removeClass('active');
});

$('.modal .inner').click(function (event) {
  event.stopPropagation();
});

$('.modal-trigger').click(function (e) {
  let target = $(this).data('target');
  $('#' + target).addClass('active');
});

//ACCORDION
$(document).ready(function () {
  $('.acc-title').first().addClass('active');
});
$('.acc-title').click(function () {
  $('.acc-title').removeClass('active');
  $(this).toggleClass('active');
  $('.acc-title:not(.active)').next().slideUp();
  $(this).next().slideToggle();
});

//////////////////////////////
//    MEMBERS DIRECTORY     //
//////////////////////////////

function urlParamsObj(source) {
  /* function returns an object with url parameters
    URL sample: www.test.com?var1=value1&var2=value2
    USE:    var params = URLparamsObj();
    alert(params.var2)  --> output: value2
    You can use it for a url-like string also: urlParamsObj("www.ok.uk?a=2&b=3")*/
  let urlStr = source
    ? source
    : window.location.search
    ? window.location.search
    : '';
  if (urlStr.indexOf('?') > -1) {
    // if there are params in URL
    let param_array = urlStr.substring(urlStr.indexOf('?') + 1).split('&'),
      theLength = param_array.length,
      params = {},
      i = 0,
      x;
    for (; i < theLength; i++) {
      x = param_array[i].toString().split('=');
      params[x[0]] = x[1];
    }
    return params;
  }
  return {};
}

//MAP TOGGLE
//If screen is big enough on load show map by default
$(document).ready(function () {
  if ($(window).width() > 992) {
    $('.map-toggle').addClass('active');
    $('#members_directory').addClass('map-open');
  }
});
//Toggle map view
$('.map-toggle').click(function () {
  $(this).toggleClass('active');
  $('#members_directory').toggleClass('map-open');
});
//Listen to window resize and force hide if too small
$(window).resize(function () {
  if ($(window).width() < 992) {
    $('.map-toggle').removeClass('active');
    $('#members_directory').removeClass('map-open');
  }
  if ($(window).width() > 992) {
    $('.left-col').css('display', 'flex');
  } else {
    $('.left-col').css('display', 'none');
  }
});

//FILTER TOGGLES
//On smaller screens toggle visibility of filters
$('.filter-toggle').click(function () {
  $(this).toggleClass('active');
  if ($(this).hasClass('active')) {
    $('.left-col').slideDown();
  } else {
    $('.left-col').slideUp();
  }
});
//For each filter toggle the options
$('.filters .btn.ghost').click(function () {
  let target = $(this).attr('data-toggle');
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $('#' + target)
      .removeClass('active')
      .slideUp(300);
  } else {
    $('.filters .btn.ghost.active').removeClass('active');
    $('.filter-container').removeClass('active').slideUp(300);
    $(this).addClass('active');
    $('#' + target)
      .addClass('active')
      .slideDown(300);
  }
});

//MICROSITE PREVIEW
//Display a preview when quick view is clicked
$(document).on('click', '.quick-view', function () {
  let micrositeLink = $(this).data('url'),
    previewContainer = document.getElementById('preview');

  $('.quick-view').removeClass('active');
  $('.member').removeClass('active');
  $(this).closest('.member').addClass('active');
  $(this).addClass('active');
  $('#members_directory').addClass('detail-open');

  previewContainer.src = micrositeLink;
});
//Close the preview section
$(document).on('click', '.quick-view.active', function () {
  $('.quick-view').removeClass('active');
  $('.member').removeClass('active');
  $('#members_directory').removeClass('detail-open');
});
$('#detail-view .closer').click(function () {
  $('.quick-view').removeClass('active');
  $('.member').removeClass('active');
  $('#members_directory').removeClass('detail-open');
});

//ACTIVE FILTERS
function activeFilters() {
  let filters = [],
    checked = $('input:checked');

  if (checked && checked.length > 0) {
    $('.filter-results .inner').html(
      '<p class="currentFilterText">Current Filters: </p>'
    );

    $(checked).each(function () {
      let slug = $(this).data('slug'),
        name = $(this).data('value'),
        type = $(this).data('type');
      if (name != 'Show Map') {
        filters.push(name);
      }
    });
  }

  if (filters && filters.length > 0) {
    $(filters).each(function () {
      $('.filter-results .inner').append(`
            <div class="item">
                <p>${this}</p>
            </div>
            `);
    });
  }

  if (checked && checked.length > 0) {
    $('#currentFilters').addClass('filter-open').show();
    $('.filter-results').slideDown();
  } else {
    $('#currentFilters').removeClass('filter-open').hide();
    $('.filter-results').slideUp();
  }
}

$('.filter-container .btn').click(activeFilters);
//Remove individual filters
$(document).on('click', '.item p', function () {
  let text = $(this).html();
  $('input[data-value="' + text + '"]').prop('checked', false);
  filterAction();
});

//CLEAR FILTERS
function clearFilters() {
  $('.filters input').prop('checked', false);
  filterAction();
  $('#currentFilters').removeClass('filter-open').hide();
  $('.filter-results').slideUp();
}
$('.clear-filters').on('click', clearFilters);

let $members = [],
  markers = [],
  map,
  member_ids = [];

function setMapOnAll(map) {
  let bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(map);
  }
}

function clearMarkers() {
  setMapOnAll(null);
}

function buildCurrentVisibleMembers() {
  let params = urlParamsObj();

  axios
    .post('/api/v1/members/search/latlng', {
      member_ids: member_ids,
      page: params.page,
      per_page: params.per_page,
      name: params.name,
      sectors: params.sectors,
      accreditations: params.accreditations,
      locations: params.locations,
      buys: params.buys,
      sells: params.sells,
      sort: params.sort,
      tours: params.tours,
    })
    .then(function (response) {
      let data = response.data.data;

      setMapOnAll(null);
      clearMarkers();
      markers = [];

      $.each(data.locations, function (i, v) {
        let infowindow = new google.maps.InfoWindow({
            content: `<div class="gm-content">
                    <div class="gm-logo">
                        <a href="${v.microsite.route}">
                            <img width="100" src="${v.info.logo}"/>
                        </a>
                    </div>
                    <div class="gm-details">
                        <div class="gm-title">
                            <a href="${v.microsite.route}">
                                <h5 style="margin-bottom: 0;">${v.name}</h5>
                            </a>
                        </div>
                        <div class="gm-address">
                            <p>${v.info.address}</p>
                        </div>
                    </div>
                </div>`,
          }),
          myLatlng = new google.maps.LatLng(v.location.lat, v.location.lng),
          marker = new google.maps.Marker({
            position: myLatlng,
            title: v.name,
            icon: '/images/made-pin.png',
          });

        google.maps.event.addListener(marker, 'click', function () {
          if (infowindow) {
            infowindow.close();
          }
          // infowindow.close();
          infowindow.open(map, marker);
          // infowindow = new google.maps.InfoWindow(map,marker);
        });

        markers.push(marker);
      });

      setMapOnAll(map);
      centerMap(map);
    });
}

function centerMap(map) {
  let bounds = new google.maps.LatLngBounds();

  $.each(markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      this.position.lat(),
      this.position.lng()
    );
    bounds.extend(latlng);
  });

  if (markers.length == 1) {
    map.setCenter(bounds.getCenter());
  } else {
    map.fitBounds(bounds);
  }
}

window.initMap = function () {
  let MapStyle = [
      {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
      },
      {
        stylers: [
          {
            hue: '#22222a',
          },
          {
            saturation: -100,
          },
          {
            gamma: 1.75,
          },
          {
            lightness: 5,
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [
          {
            visibility: 'on',
          },
          {
            lightness: 5,
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            lightness: 5,
          },
        ],
      },
    ],
    myLatlng = new google.maps.LatLng(52.4751, -1.8298),
    mapOptions = {
      zoom: 14,
      center: myLatlng,
      styles: MapStyle,
      mapTypeControl: false,
      streetViewControl: false,
    };

  //map = new google.maps.Map(document.getElementsByClassName("map-canvas"), mapOptions);
  map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
};

window.followMember = function (name) {
  axios
    .post('/api/v1/members/search/follow', {
      name: name,
    })
    .then(function (response) {
      let swalre = response.data.swal,
        member = response.data.member;

      if (response.data.redirect === true) {
        swal2({
          type: swalre.type,
          title: swalre.title,
          text: swalre.text,
          footer:
            '<a href="' + member.microsite + '">Visit ' + member.name + '</a>',
          showCancelButton: true,
          confirmButtonText: 'Login',
          cancelButtonText: 'Register',
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.location.href = '/login';
          } else {
            window.location.href = '/register';
          }
        });
      } else {
        swal2({
          type: swalre.type,
          title: swalre.title,
          text: swalre.text,
          footer:
            '<a href="' + member.microsite + '">Visit ' + member.name + '</a>',
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

function setOneQueryStringParameter(name, value) {
  const params = new URLSearchParams(location.search);

  params.set(name, value);

  window.history.replaceState({}, '', `${location.pathname}?${params}`);
}

function searchMembers(name) {
  let params = urlParamsObj();

  setOneQueryStringParameter('name', name);

  axios
    .post('/api/v1/members/search', {
      page: params.page,
      per_page: params.per_page,
      name: params.name,
      sectors: params.sectors,
      accreditations: params.accreditations,
      locations: params.locations,
      buys: params.buys,
      sells: params.sells,
      sort: params.sort,
      tours: params.tours,
    })
    .then(function (response) {
      buildMembers(
        response.data.data.members,
        response.data.meta,
        params,
        true,
        false
      );
    });
}

function getMembers(URLParams, remove) {
  let params = {
    page: URLParams.page,
    per_page: URLParams.per_page,
    name: URLParams.name,
    sectors: URLParams.sectors,
    accreditations: URLParams.accreditations,
    locations: URLParams.locations,
    buys: URLParams.buys,
    sells: URLParams.sells,
    sort: URLParams.sort,
    tours: URLParams.tours,
  };

  axios
    .post('/api/v1/members/search', {
      per_page: params.per_page,
      name: params.name,
      sectors: params.sectors,
      accreditations: params.accreditations,
      locations: params.locations,
      buys: params.buys,
      sells: params.sells,
      sort: params.sort,
      tours: params.tours,
    })
    .then(function (response) {
      $members.push(response.data.data.members);
      buildMembers(
        response.data.data.members,
        response.data.meta,
        params,
        false,
        false
      );
    })
    .catch(function (error) {
      console.log(error);
    });
}

function buildMembers(members, meta, params, remove, reload) {
  let loading = $('.loading-spinner'),
    loadMore = $('#loadmore'),
    membersList = $('.list-inner');
  membersList.html('');
  if (reload) {
    location.reload();
  } else {
    if (remove) {
      $('.member').remove();
      $('.results__empty').remove();
      loading.show();
    }

    loading.hide();
    loadMore.remove();

    if (meta && meta.pagination && meta.pagination.total) {
      $('.members-found').text(
        `${meta.pagination.total} ${
          meta.pagination.total > 1 ? 'members' : 'member'
        }`
      );
    } else {
      $('.members-found').text('No members found');
    }

    if (members && members.length > 0) {
      $.each(members, function (i, v) {
        var chatClass = 'd-none';
        var chatClassM = '';
        if (v.enable_live_chat) chatClass = '';
        var matterport = '';
        if (v.matterport.m_1) {
          matterport = v.matterport.m_1;
          chatClassM = '';
        } else if (v.matterport.m_2) {
          matterport = v.matterport.m_2;
          chatClassM = '';
        } else if (v.matterport.m_3) {
          matterport = v.matterport.m_3;
          chatClassM = '';
        } else {
          matterport = '';
          chatClassM = 'd-none';
        }
        var followClass = '';
        var followingClass = 'd-none';
        if (v.following) {
          followClass = 'd-none';
          followingClass = '';
        }
        member_ids.push(v.id);
        //console.log(meta.pagination);
        membersList.append(
          // '<article class="member">' +
          //     '<div class="inner">' +
          //         '<div class="logo-container">' +
          //             `<div class="logo">` +
          //                 `<img src="` + v.logo + `">` +
          //             `</div>` +
          //         '</div>' +
          //         '<div class="info">' +
          //             '<h5>' +
          //                 '<span class="name">' + v.name +'</span>' +
          //                 '<span class="plan ' + v.membership.name.toLowerCase() +'">' + v.membership.name +'</span>' + '<span class="chat-enabled ' + chatClass + '">Chat</span>' +
          //             '</h5>' +
          //             '<ul class="member-contacts">' +
          //                 '<li><i class="far fa-home"></i>'+ v.address +'</li>' +
          //                 '<li><i class="far fa-phone"></i>'+ v.telephone +'</li>' +
          //             '</ul>' +
          //             '<p>' + (v.natureOfBusiness ? v.natureOfBusiness : '') + '</p>' +
          //         '</div>' +
          //         '<div class="actions">' +
          //             '<button class="follow" onclick="followMember(\'' + v.name + '\')"><i class="far fa-plus"></i><span> Follow</span></button>' +
          //             '<button class="quick-view" data-url="' + v.microsite.replace("http://", "https://") + '"><i class="far fa-eye"></i><span> Quick View</span></button>' +
          //             '<a class="btn microsite" href="' + v.microsite + '"><i class="far fa-sign-in"></i><span> Visit Microsite</span></a>' +
          //         '</div>' +
          //     '</div>' +
          // '</article>'

          `<div class="col-xl-3 col-lg-4 col-xs-6 col-6 mb-4">
                        <div class="member-card d-flex flex-column h-100">
                            <div class="member-logo d-flex align-items-center justify-content-center">
                                <img src="${v.logo}" alt="${
            v.name
          }" class="d-block mx-auto m-0">
                            </div>
                            <div class="member-contact-wrpr">
                                <span class="mcard-tooltip top">
                                    <span class="tooltiptext">Locate us</span>
                                    <a href="${
                                      v.microsite
                                    }/contact-us" target="_blank" class="member-contact-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-map-pin" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                            <circle cx="12" cy="11" r="3"></circle>
                                            <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
                                        </svg>
                                    </a>
                                </span>
                                <span class="mcard-tooltip">
                                    <span class="tooltiptext">Call us</span>
                                    <a href="tel:${
                                      v.telephone
                                    }" class="member-contact-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-phone" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                            <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"></path>
                                        </svg>
                                    </a>
                                </span>
                                <span class="mcard-tooltip ${chatClassM}">
                                    <span class="tooltiptext">3D Tour</span>
                                    <a
                                    href="#!" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#openTourPopup" 
                                    role="button" 
                                    class="member-contact-icon show3dTour" 
                                    data-src="${matterport}" 
                                    data-id="${v.id}"  
                                    data-member_name="${v.name}"
                                    data-microsite="${v.microsite}"
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hexagon-3d" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.25" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M19 6.844a2.007 2.007 0 0 1 1 1.752v6.555c0 .728 -.394 1.399 -1.03 1.753l-5.999 3.844a1.995 1.995 0 0 1 -1.942 0l-6 -3.844a2.007 2.007 0 0 1 -1.029 -1.752v-6.556c0 -.729 .394 -1.4 1.029 -1.753l6 -3.583a2.05 2.05 0 0 1 2 0l6 3.584h-.03z"></path>
                                        <path d="M12 16.5v4.5"></path>
                                        <path d="M4.5 7.5l3.5 2.5"></path>
                                        <path d="M16 10l4 -2.5"></path>
                                        <path d="M12 7.5v4.5l-4 2"></path>
                                        <path d="M12 12l4 2"></path>
                                        <path d="M12 16.5l4 -2.5v-4l-4 -2.5l-4 2.5v4z"></path>
                                    </svg>
                                    </a>
                                </span>

                            </div>
                            <div class="about-member flex-fill">
                                <span class="membership-type rounded-pill text-uppercase" data-type="${v.membership.name.toLowerCase()}">
                                ${v.membership.name}</span>
                                <h3 class="card-title text-uppercase mb-0">${
                                  v.name
                                }</h3>
                            </div>
                            <div class="card-btn-sec justify-content-between">
                                <div class="p-0 m-0 btn-wrap d-none d-md-block">
                                    <button onclick="followMember('${
                                      v.name
                                    }')" class="follow follow-us-btn d-flex justify-content-start ${followClass}">
                                        <span class="follow--us--icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
                                                </svg>
                                        </span> 
                                        <span class="follow--us---text">Follow</span>
                                    </button>
                                    <button type="button"
                                    class="follow follow-us-btn d-flex justify-content-start following ${followingClass}">
                                        <span class="follow--us--icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                              </svg>
                                        </span> 
                                        <span class="follow--us---text">Following</span>
                                    </button>
                                </div>
                                <div class="btn-wrap d-none d-md-block">
                                    <a href="!#" class="open_quick_view" data-site_url="${
                                      v.microsite
                                    }" data-company_name="${
            v.name
          }">Quick View</a>
                                </div>
                            </div>
                            <div class="visit-btn-wrap">
                                <a href="${
                                  v.microsite
                                }" class="visit-btn">Visit Microsite</a>
                            </div>
                        </div>
                    </div>
                    `
        );
      });
    } else {
      membersList.append(
        '<p class="results__empty" style="padding: 10px 15px;">No Results Found</p>'
      );
    }
    const pagination = (c, m) => {
      var current = c,
        last = m,
        delta = 2,
        left = current - delta,
        right = current + delta + 1,
        range = [],
        rangeWithDots = [],
        l,
        html = '';

      for (let i = 1; i <= last; i++) {
        if (i == 1 || i == last || (i >= left && i < right)) {
          range.push(i);
        }
      }

      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
            html += `
                        <li class="page-item">
                        <a class="page-link" href="${l + 1}" 
                        onclick="loadMoreMembers('/api/v1/members/search?page=${
                          l + 1
                        }')">
                        ${l + 1}
                        </a>
                        </li>
                        `;
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
            html += `
                        <li class="page-item disabled">
                        <span class="page-link">
                        ...
                        </span>
                        </li>
                        `;
          }
        }
        rangeWithDots.push(i);
        if (i == current) {
          html += `
                    <li class="page-item ${i == current ? `active` : ``}">
                    <span class="page-link">
                    ${i}
                    </span>
                    </li>
                    `;
        } else {
          html += `
                    <li class="page-item">
                    <a class="page-link" href="#${i}" 
                    onclick="loadMoreMembers('/api/v1/members/search?page=${i}')">
                    ${i}
                    </a>
                    </li>
                    `;
        }
        l = i;
      }
      console.log(rangeWithDots);
      return html;
    };
    if (meta.pagination) {
      // membersList.append(
      //     '<div id="loadmore">'+
      //         '<button onclick="loadMoreMembers(\'' + meta.pagination.next_page_url+ '\')" class="load">Load More Members</button>'+
      //     '</div>'
      // );

      /* var paginationList = '';

            if (meta.pagination.prev_page_url) {
               paginationList += `<li class="page-item arrow-left"><a class="page-link" href="#" onclick="loadMoreMembers(${meta.pagination.prev_page_url})"><img src="/frontend_new/assets/images/member/arrow-lefts.svg" alt=""></a></li>`;
            }

            for (let i = 1; i <= meta.pagination.last_page; i++) {
                paginationList += `<li class="page-item"><a class="page-link `;
                if(meta.pagination.current_page === i) {
                    paginationList += `active`;
                }
                paginationList += `" href="#" onclick="loadMoreMembers('/api/v1/members/search?page=`+ i +`')">`+ i +`</a></li>`;
            }

            if (meta.pagination.next_page_url) {
                paginationList += `<li class="page-item arrow-right"><a class="page-link" href="#" onclick="loadMoreMembers(${meta.pagination.next_page_url})"><img src="/frontend_new/assets/images/member/arrow-right.svg" alt=""></a></li>`;
            } */

      membersList.append(
        `<nav class="news__pagination pagination-wrap"><ul class="pagination justify-content-center">${pagination(
          meta.pagination.current_page,
          meta.pagination.last_page
        )}</ul></nav>`
      );

      //membersList.append(pagination(meta.pagination.current_page, meta.pagination.last_page));
    }

    buildCurrentVisibleMembers();
  }
}
window.loadMoreMembers = function (next_page_url) {
  let params = urlParamsObj(),
    nextPage = urlParamsObj(next_page_url);

  axios
    .post('/api/v1/members/search', {
      page: nextPage.page,
      per_page: params.per_page,
      name: params.name,
      sectors: params.sectors,
      accreditations: params.accreditations,
      location: params.location,
      buys: params.buys,
      sells: params.sells,
      sort: params.sort,
      tours: params.tours,
      sic_codes: params.sic_codes,
      tenants: params.tenants,
    })
    .then(function (response) {
      buildMembers(
        response.data.data.members,
        response.data.meta,
        params,
        false,
        false
      );
    });
};

//FILTER ACTION
function filterAction() {
  let locations = [];
  $('#filter-locations')
    .find(':checked')
    .each(function () {
      locations.push($(this).val());
    });
  locations = locations.join(',');

  let sectors = [];
  $('#filter-sectors')
    .find(':checked')
    .each(function () {
      sectors.push($(this).val());
    });
  sectors = sectors.join(',');

  let sic_codes = [];
  $('#filter-sic_codes, #filter-sic_codes-mobile')
    .find(':checked')
    .each(function () {
      sic_codes.push($(this).val());
    });
  sic_codes = sic_codes.join(',');
  let tenants = [];
  $('#filter-tenants, #filter-tenants-mobile')
    .find(':checked')
    .each(function () {
      tenants.push($(this).val());
    });
  tenants = tenants.join(',');

  let accreditations = [];
  $('#filter-accreditations, #filter-accreditations-mobile')
    .find(':checked')
    .each(function () {
      accreditations.push($(this).val());
    });
  accreditations = accreditations.join(',');

  let buys = [];
  $('#filter-buys, #filter-buys-mobile')
    .find(':checked')
    .each(function () {
      buys.push($(this).val());
    });
  buys = buys.join(',');

  let sells = [];
  $('#filter-sells, #filter-sells-mobile')
    .find(':checked')
    .each(function () {
      sells.push($(this).val());
    });
  sells = sells.join(',');

  let hasTour = '';
  if ($('#3dTourButton').is(':checked')) {
    hasTour = 1;
  }

  window.history.replaceState(
    {},
    '',
    //`members?locations=${locations}&sectors=${sectors}&accreditations=${accreditations}&buys=${buys}&sells=${sells}&tours=${hasTour}`
    `members?locations=${locations}&sic_codes=${sic_codes}&tenants=${tenants}&accreditations=${accreditations}&buys=${buys}&sells=${sells}&tours=${hasTour}`
  );

  let params = urlParamsObj();

  axios
    .post('/api/v1/members/search', {
      per_page: params.per_page,
      name: params.name,
      sectors: params.sectors,
      accreditations: params.accreditations,
      locations: params.locations,
      buys: params.buys,
      sells: params.sells,
      sort: params.sort,
      tours: params.tours,
      sic_codes: params.sic_codes,
      tenants: params.tenants,
    })
    .then(function (response) {
      buildMembers(
        response.data.data.members,
        response.data.meta,
        params,
        true,
        false
      );
    })
    .catch(function (error) {
      console.log(error);
    });

  activeFilters();
}

$(document).ready(function () {
  if ($('#members_directory').length) {
    let params = urlParamsObj(),
      search = $('#member-search');
    let searchMobile = $('#member-search-mobile');

    if (params.name) {
      search.focus().val(params.name);
    }

    if (!params.page) {
      params.page = 1;
    }

    if (!params.per_page) {
      params.per_page = 12;
    }

    if (params.sort) {
      let text = $('#sort');
      if (params.sort === 'abc') {
        text.html('<i class="far fa-sort"></i>Sort: Name');
      } else {
        text.html('<i class="far fa-sort"></i>Sort: Rank');
      }
    }

    /*search.keyup(debounce(function(){
            searchMembers(search.val());

        }, 500));*/

    search.on('keyup', function (event) {
      searchMembers(search.val());
    });
    searchMobile.on('keyup', function (event) {
      searchMembers(searchMobile.val());
    });

    search.on('change', function (event) {
      console.log(search.val());
      searchMembers(search.val());
    });
    searchMobile.on('change', function (event) {
      console.log(searchMobile.val());
      searchMembers(searchMobile.val());
    });

    getMembers(params, false);

    console.log(member_ids);

    buildCurrentVisibleMembers();
    initMap();
    $('.filter-form').submit(function (event) {
      event.preventDefault();

      filterAction();

      $('.filter-container').removeClass('active').slideUp();
      $('.filters .btn').removeClass('active');
    });

    $('#3dTourButton').on('change', function (event) {
      filterAction();

      $('.filter-container').removeClass('active').slideUp();
      $('.filters .btn').removeClass('active');
    });

    let url = urlParamsObj();

    if (url.locations && url.locations.length) {
      let locations = url.locations.split(',');

      $('#filter-locations :checkbox').each(function () {
        if (locations.includes($(this).val())) {
          $(this).prop('checked', true);
        }
      });
    }

    if (url.sectors && url.sectors.length) {
      let sectors = url.sectors.split(',');

      $('#filter-sectors :checkbox').each(function () {
        if (sectors.includes($(this).val())) {
          $(this).prop('checked', true);
        }
      });
    }

    if (url.accreditations && url.accreditations.length) {
      let accreditations = url.accreditations.split(',');

      $(
        '#filter-accreditations :checkbox, #filter-accreditations-mobile :checkbox'
      ).each(function () {
        if (accreditations.includes($(this).val())) {
          $(this).prop('checked', true);
        }
      });
    }

    if (url.buys && url.buys.length) {
      let buys = url.buys.split(',');

      $('#filter-buys :checkbox, #filter-buys-mobile :checkbox').each(
        function () {
          if (buys.includes($(this).val())) {
            $(this).prop('checked', true);
          }
        }
      );
    }

    if (url.sells && url.sells.length) {
      let sells = url.sells.split(',');

      $('#filter-sells :checkbox, #filter-sells-mobile :checkbox').each(
        function () {
          if (sells.includes($(this).val())) {
            $(this).prop('checked', true);
          }
        }
      );
    }

    // filterAction();
    /* $('#updateFilters').submit(function(e){
             e.preventDefault();

             let array = $(this).serializeArray();

             //clearFilters();

             //renderFilters();

             $.each(array, function(i, v){

                 let name = Object.values(v)[0].replace('[]', ''),
                     value = Object.values(v)[1];

                 if(name === 'location'){
                     if(value === 'all'){
                         setOneQueryStringParameter(name, '');
                     } else{
                         setOneQueryStringParameter(name, value);
                     }
                 } else{
                     setQueryStringParameter(name, value);
                 }

             });

             let params = urlParamsObj();

             axios.post('/api/v1/members/search', {
                 per_page: params.per_page,
                 name: params.name,
                 sectors: params.sectors,
                 accreditations: params.accreditations,
                 location: params.location,
                 buys: params.buys,
                 sells: params.sells,
                 sort: params.sort,
                 tours: params.tours
             })
             .then(function (response) {
                 buildMembers(response.data.data.members, response.data.meta, params, true, true);
             })
             .catch(function (error) {
                 console.log(error);
             });

         });*/
  }

  /** New code - START */
  $('input.membership-type-radio').keydown(function (event) {
    if (event.key === 'ArrowRight' || event.keyCode === 39) {
      if ($(this).next().length > 0) {
        $(this).next().trigger('click');
      } else {
        if ($(this).prev().length > 0) {
          $(this).prev().trigger('click');
        }
      }
    }

    if (event.key === 'ArrowLeft' || event.keyCode === 37) {
      if ($(this).prev().length > 0) {
        $(this).prev().trigger('click');
      } else {
        if ($(this).next().length > 0) {
          $(this).next().trigger('click');
        }
      }
    }
  });

  $('label.membership-type-radio-label').click(function () {
    var inputId = $(this).attr('for');
    $('#' + inputId).prop('checked', true);
    $('#' + inputId).focus();
  });
  /** New code - END */

  $('li.cta-item a').removeAttr('title');

  $(document).on('mouseover', 'li.cta-item a', function (event) {
    var successMsg = $(
      '<span class="link-label">' + $(this).data('label') + '</span>'
    );
    $(this).append(successMsg);
    successMsg.fadeIn();
  });

  $(document).on('mouseleave', 'li.cta-item a', function (event) {
    var $this = $(this);
    $(this)
      .find('.link-label')
      .animate(
        {
          opacity: 0,
        },
        120,
        function () {
          $this.html('');
        }
      );
  });

  var shareBtn = $('a.copy-link-btn');

  if (
    typeof shareBtn !== typeof undefined &&
    typeof shareBtn !== typeof false
  ) {
    if (shareBtn.length > 0) {
      var shareLink = $('textarea#current-url');

      // Copies a string to the clipboard. Must be called from within an event handler such as click.
      // May return false if it failed, but this is not always
      // possible. Browser support for Chrome 43+, Firefox 42+, Edge and IE 10+.
      // No Safari support, as of (Nov. 2015). Returns false.
      // IE: The clipboard feature may be disabled by an adminstrator. By default a prompt is
      // shown the first time the clipboard is used (per session).
      // source: https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
      function copyToClipboard(text) {
        if (window.clipboardData && window.clipboardData.setData) {
          // IE specific code path to prevent textarea being shown while dialog is visible.
          return clipboardData.setData('Text', text);
        } else if (
          document.queryCommandSupported &&
          document.queryCommandSupported('copy')
        ) {
          var textarea = document.createElement('textarea');
          textarea.classList.add('hidden');
          textarea.textContent = text;
          textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
          document.body.appendChild(textarea);
          textarea.select();
          try {
            return document.execCommand('copy'); // Security exception may be thrown by some browsers.
          } catch (ex) {
            return false;
          } finally {
            document.body.removeChild(textarea);
          }
        }
      }

      shareBtn.click(function (event) {
        event.preventDefault();
        var btn = $(this);
        var result = copyToClipboard($(this).data('url'));
        if (result) {
          if ($('.link-label').length === 0) {
            var successMsg = $('<span class="link-label">Link copied!</span>');
            $(this).append(successMsg);
            successMsg.fadeIn();
            window.setTimeout(function () {
              successMsg.animate(
                {
                  opacity: 0,
                },
                200,
                function () {
                  btn.html('');
                }
              );
            }, 3000);
          } else {
            $(this).find('.link-label').text('Link copied!');
          }
        }
      });
    }
  }

  if (window.sessionStorage) {
    if (sessionStorage.getItem('bbe2020')) {
      $('#expo_popup').css('display', 'none');
    } else {
      function closeExpoPopup() {
        sessionStorage.setItem('bbe2020', 'closed');
        window.setTimeout(function () {
          $('#expo_popup').css('display', 'none');
        }, 500);
      }

      window.setTimeout(function () {
        $('#expo_popup').addClass('visible');
      }, 4000);

      $('.ep-content').click(function (event) {
        event.preventDefault();

        $('#expo_popup').removeClass('visible');
        closeExpoPopup();
      });

      $('.ep-card, .ep-card .ep-card-i, .ep-card .popup-cta, .ep-card a').click(
        function (event) {
          event.stopPropagation();
        }
      );

      $('#btn-expo_popup').click(function (event) {
        event.preventDefault();

        $('#expo_popup').removeClass('visible');
        closeExpoPopup();

        if (this === event.target) {
          $('#expo_popup').fadeOut(250);
        }
      });
    }
  }
});
